// ===== Types =====

export interface SalaryPiggyBankUserRecord {
    id: number;
    user_id: number;
    autopay_amount: number;
    autopay: boolean;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
    user: {
        id: number;
        secret_cookie: string;
        name: string;
        surname: string;
        email: string;
        photo: string;
    } | null;
}

export interface SalaryPiggyBankPaymentRecord {
    id: number;
    user_id: number;
    amount: string;
    type: "manual" | "auto";
    currency: "USD" | "USDT" | "MIX";
    total: string;
    created_at: string;
    updated_at: string;
    user: {
        id: number;
        secret_cookie: string;
        name: string;
        surname: string;
        photo: string;
    } | null;
}

export interface SalaryPiggyBankSettings {
    goal_amount: number;
    min_amount: number;
}

export interface SalaryPiggyBankMonthlyStats {
    paid_count: number;
    total_collected: number;
}

export interface SalaryPiggyBankHistoricalStat {
    year: number;
    month: number;
    label: string;       // e.g. "02.2026"
    total_users: number;
    total_collected: number;
}

export interface SalaryPiggyBankHistoricalStatsResponse {
    data: SalaryPiggyBankHistoricalStat[];
}

export interface SalaryPiggyBankPaginationMeta {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
    from: number | null;
    to: number | null;
}

export interface SalaryPiggyBankUsersResponse {
    data: SalaryPiggyBankUserRecord[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

export interface SalaryPiggyBankPaymentsResponse {
    data: SalaryPiggyBankPaymentRecord[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

export interface SalaryPiggyBankUsersParams {
    page?: number;
    per_page?: number;
    search?: string;
    status?: "active" | "deleted" | "";
}

export interface SalaryPiggyBankPaymentsParams {
    page?: number;
    per_page?: number;
    user_id?: number;
    type?: "manual" | "auto" | "";
    date_from?: string;
    date_to?: string;
}

// ===== Endpoints =====

export const salaryPiggyBankEndpoints = {
    getSalaryPiggyBankUsers: {
        query: (params: SalaryPiggyBankUsersParams) => ({
            url: "/admin/salary-piggy-bank/users",
            params,
        }),
    },
    getSalaryPiggyBankPayments: {
        query: (params: SalaryPiggyBankPaymentsParams) => ({
            url: "/admin/salary-piggy-bank/payments",
            params,
        }),
    },
    getSalaryPiggyBankSettings: {
        query: () => ({
            url: "/admin/salary-piggy-bank/settings",
        }),
    },
    updateSalaryPiggyBankSettings: {
        query: (data: SalaryPiggyBankSettings) => ({
            url: "/admin/salary-piggy-bank/settings",
            method: "PUT",
            body: data,
        }),
    },
    getSalaryPiggyBankMonthlyStats: {
        query: () => ({
            url: "/admin/salary-piggy-bank/monthly-stats",
        }),
    },
    getSalaryPiggyBankHistoricalStats: {
        query: () => ({
            url: "/admin/salary-piggy-bank/historical-stats",
        }),
    },
    removeSalaryPiggyBankUser: {
        query: (userId: number) => ({
            url: `/admin/salary-piggy-bank/users/${userId}`,
            method: "DELETE",
        }),
    },
    restoreSalaryPiggyBankUser: {
        query: (userId: number) => ({
            url: `/admin/salary-piggy-bank/users/${userId}/restore`,
            method: "POST",
        }),
    },
};

export const salaryPiggyBankTags = ["SalaryPiggyBank", "SalaryPiggyBankSettings", "SalaryPiggyBankStats"];
